module.exports = __webpack_public_path__ + "static/download/poster_RGB.ver2_0_2.jpeg?464d8889";